module.exports = __webpack_public_path__ + "static/translations-18754b6f879bdc5b8183756710e5965d.gif";